import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
var any = PropTypes.any,
    string = PropTypes.string;
var propTypes = {
  left: any,
  right: any,
  className: string,
  padding: any,
  center: any,
  backgroundColor: any
};
var defaultProps = {
  padding: "8px"
};
var groupStyles = {
  display: "flex",
  alignItems: "center",
  flexGrow: 0,
  justifyContent: "space-between",
  flexWrap: "wrap"
};
var spacerStyles = {
  flexGrow: 1,
  alignSelf: "center"
};
var centerStyles = {
  flexGrow: 0
};

var Bar = function Bar(_ref) {
  var left = _ref.left,
      right = _ref.right,
      center = _ref.center,
      padding = _ref.padding,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("et--bar", className),
    style: {
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      justifyContent: center ? "center" : "space-between",
      padding: padding,
      backgroundColor: backgroundColor
    }
  }, center ? /*#__PURE__*/React.createElement("div", {
    classname: "et--bar--center",
    style: {
      flexGrow: 0
    }
  }, center) : /*#__PURE__*/React.createElement(Fragment, null, left && /*#__PURE__*/React.createElement("div", {
    className: "et--bar--left",
    style: groupStyles
  }, left), /*#__PURE__*/React.createElement("div", {
    className: "et--bar--center",
    style: spacerStyles
  }), right && /*#__PURE__*/React.createElement("div", {
    className: "et--bar--right",
    style: groupStyles
  }, right)));
};

Bar.displayName = "Bar";
Bar.propTypes = propTypes;
Bar.defaultProps = defaultProps;

var Spacer = function Spacer(_ref2) {
  var width = _ref2.width;
  return /*#__PURE__*/React.createElement("span", {
    className: "et--bar--spacer",
    style: {
      width: width
    }
  }, " ");
};

Spacer.displayName = "Bar.Spacer";
Spacer.defaultProps = {
  width: "8px"
};
Spacer.propTypes = {
  width: any
};
Bar.Spacer = Spacer;
export { Spacer };
export default Bar;